module.exports = __webpack_public_path__ + "img/face-photo.b14cad27.svg";